import type { WorkType } from '@vwt/contracts';

const PREFIX: Partial<Record<WorkType, string>> = { BUG: 'fix', MAINTENANCE: 'chore', INFRASTRUCTURE: 'infra' };

/**
 * Suggested git branch for a work item, for example feat/VAM-42-swap-history-export. The key in
 * the name lets commits and pull requests on the branch link themselves to the item.
 */
export function branchName(item: { key: string; title: string; type: WorkType }): string {
  const slug = item.title
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  let short = slug.slice(0, 40);
  if (slug.length > 40 && short.includes('-')) short = short.slice(0, short.lastIndexOf('-'));
  return `${PREFIX[item.type] ?? 'feat'}/${item.key}${short ? `-${short}` : ''}`;
}
